import { render } from "./add-group-modal.vue?vue&type=template&id=d145e3d2"
import script from "./add-group-modal.vue?vue&type=script&lang=js"
export * from "./add-group-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__